module.exports = __webpack_public_path__ + "static/media/(V)_MG_5702_-_Cia_Termal_Beachewear_-_Moda_Masculina_Infantil.6ab303b5.jpg";